import { render, staticRenderFns } from "./monthlyMilkProductionDayTotal.vue?vue&type=template&id=430b54bd&scoped=true&"
import script from "./monthlyMilkProductionDayTotal.vue?vue&type=script&lang=js&"
export * from "./monthlyMilkProductionDayTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b54bd",
  null
  
)

export default component.exports